import { ColumnType } from '@/configs/enums/website';
import { generateSorter } from '@/utils/common/sort-util';

/**
 * 获取栏目页面url（用于admin）
 * @param {Number} columnType 栏目类型
 * @param {Number} columnId 栏目id
 * @param {Number} viewType 查看类型
 * @param {Number} previewId 预览模板Id
 * @returns
 */
const getColumnPageUrlForAdmin = (
  columnType,
  columnId,
  columnUrl,
  customColumnPageTypeId,
  viewType,
  previewId,
) => {
  if (!previewId) {
    return viewType === 'preview' ? '请先配置官网' : '请先配置官网模板';
  }

  switch (columnType) {
    case ColumnType.导航栏目:
      return columnUrl || '请先配置导航栏目的下级栏目';
    case ColumnType.链接栏目:
      // 单独处理“首页”
      if (columnUrl === '/') {
        return `${import.meta.env.VITE_VUE_APP_WebSite_HOST}/${viewType}/${previewId}`;
      }
      return columnUrl;
    case ColumnType.单页面栏目:
      return `${import.meta.env.VITE_VUE_APP_WebSite_HOST}/${viewType}/${previewId}/content/single/${columnId}`;
    case ColumnType.自定义模板页栏目:
      return `${import.meta.env.VITE_VUE_APP_WebSite_HOST}/${viewType}/${previewId}/content/custom/${columnId}/${customColumnPageTypeId ?? 0}`;
    default:
      return `${import.meta.env.VITE_VUE_APP_WebSite_HOST}/${viewType}/${previewId}/content/list/${columnId}`;
  }
};

/**
 * 获取栏目页面url（用于website）
 * @param {Number} columnType 栏目类型
 * @param {Number} columnId 栏目id
 * @param {Number} viewType 查看类型
 * @param {Number} previewId 预览模板Id
 * @returns
 */
const getColumnPageUrlForWebsite = (
  columnType,
  columnId,
  columnUrl,
  customColumnPageTypeId,
  viewType,
  previewId,
) => {
  const urlPrefix = viewType === 'website' ? '' : `/${viewType}/${previewId}`;
  switch (columnType) {
    case ColumnType.导航栏目:
      return columnUrl;
    case ColumnType.链接栏目:
      // 单独处理“首页”
      if (columnUrl === '/') {
        return `${urlPrefix === '' ? '/' : urlPrefix}`;
      }
      return columnUrl;
    case ColumnType.单页面栏目:
      return `${urlPrefix}/content/single/${columnId}`;
    case ColumnType.自定义模板页栏目:
      return `${urlPrefix}/content/custom/${columnId}/${customColumnPageTypeId ?? 0}`;
    default:
      return `${urlPrefix}/content/list/${columnId}`;
  }
};

/**
 * 获取导航栏目url（用于admin）
 * @param {Array} subColumnList 下级栏目列表
 * @param {Number} viewType 查看类型
 * @param {Number} previewId 预览模板Id
 * @returns
 */
const getNavColumnUrlForAdmin = (subColumnList, viewType, previewId) => {
  const subFirstColumn = subColumnList.sort(generateSorter('sortNum'))[0];
  return getColumnPageUrlForAdmin(
    subFirstColumn.columnType,
    subFirstColumn.id,
    subFirstColumn.hrefURL,
    null,
    viewType,
    previewId,
  );
};

/**
 * 获取栏目页面url
 * @param {Number} columnType 栏目类型
 * @param {Number} columnId 栏目id
 * @param {Number} viewType 查看类型
 * @param {Number} previewId 预览模板Id
 * @returns
 */
const getColumnPageUrl = (columnType, columnId, viewType, previewId) => {
  return ColumnType.单页面栏目 === columnType
    ? `${import.meta.env.VITE_VUE_APP_WebSite_HOST}/${viewType}/${previewId}/content/single/${columnId}`
    : `${import.meta.env.VITE_VUE_APP_WebSite_HOST}/${viewType}/${previewId}/content/list/${columnId}`;
};

/**
 * 获取栏目页面url
 * @param {Number} columnType 栏目类型
 * @param {Number} columnId 栏目id
 * @param {Number} viewType 查看类型
 * @param {Number} previewId 预览模板Id
 * @returns
 */
const getColumnPageUrlNew = (columnType, columnId, viewType, previewId) => {
  return ColumnType.单页面栏目 === columnType
    ? `/${viewType}/${previewId}/content/single/${columnId}`
    : `/${viewType}/${previewId}/content/list/${columnId}`;
};

/**
 * 获取素材页面url（用于admin）
 * @param {Number} columnId 栏目id
 * @param {Number} materialId 素材id
 * @param {Number} viewType 查看类型
 * @param {Number} previewId 预览模板Id
 * @returns
 */
const getMaterialPageUrlForAdmin = (
  columnId,
  materialId,
  viewType,
  previewId,
) => {
  if (!previewId) {
    return viewType === 'preview' ? '请先配置官网' : '请先配置官网模板';
  }

  return `${import.meta.env.VITE_VUE_APP_WebSite_HOST}/${viewType}/${previewId}/content/detail/${columnId}/${materialId}`;
};

/**
 * 获取素材页面url（用于website）
 * @param {Number} columnId 栏目id
 * @param {Number} materialId 素材id
 * @param {Number} viewType 查看类型
 * @param {Number} previewId 预览模板Id
 * @returns
 */
const getMaterialPageUrlForWebsite = (
  columnId,
  materialId,
  viewType,
  previewId,
) => {
  const urlPrefix = viewType === 'website' ? '' : `/${viewType}/${previewId}`;
  return `${urlPrefix}/content/detail/${columnId}/${materialId}`;
};

export {
  getColumnPageUrlForAdmin,
  getColumnPageUrlForWebsite,
  getNavColumnUrlForAdmin,
  // getColumnPageUrl,
  // getColumnPageUrlNew,
  getMaterialPageUrlForAdmin,
  getMaterialPageUrlForWebsite,
};
